import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { PromotionCodeListItem } from "../../../service/api-response/PromotionCodesSuccessResponse";

export const LIST_PROMOTION_CODES_SUCCESS =
  "PROMOTION-CODE:LIST_PROMOTION_CODES_SUCCESS";

export interface ListPromotionCodesSuccessAction extends Action {
  type: typeof LIST_PROMOTION_CODES_SUCCESS;
  organization: OrganizationKeyName;
  data: PromotionCodeListItem[];
}

export const listPromotionCodesSuccessAction = (
  organization: OrganizationKeyName,
  data: PromotionCodeListItem[]
): ListPromotionCodesSuccessAction => ({
  type: LIST_PROMOTION_CODES_SUCCESS,
  organization,
  data,
});
